import { render, staticRenderFns } from "./StatisticsNewDevices.vue?vue&type=template&id=0061ef18&scoped=true&"
import script from "./StatisticsNewDevices.vue?vue&type=script&lang=js&"
export * from "./StatisticsNewDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061ef18",
  null
  
)

export default component.exports